export const ShippingTypes = {
  UNAVAILABLE: 'unavailable',
  TAKEAWAY: 'takeaway',
  DELIVERY: 'delivery',
  TO_AGREE: 'to_agree',
}
